import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import termsHTML from '../terms-of-service.html?raw'

export default function Terms() {
  const { t } = useTranslation()
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">{t('legal.backToApp')}</Link>
        <div dangerouslySetInnerHTML={{ __html: termsHTML }} />
      </div>
    </div>
  )
}
